import React from 'react';

import cn from 'classnames';

import { utilityClasses } from '../../../css/utils';

import styles from './Spinner.module.css';

export interface SpinnerProps {
  /**
   * Size of the spinner
   */
  size?: number;

  /**
   * Color of the spinner
   */
  color?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 30, color }) => {
  return (
    <div className={cn(utilityClasses['center-children'], styles.spinner)}>
      <svg
        fill="none"
        height={size}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        style={{
          stroke: color,
        }}
        viewBox="0 0 24 24"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
};
